export default __webpack_public_path__ + "static/media/money.19008121.svg";